export default __webpack_public_path__ + "static/media/WindowShoppin.5f46d10f.png";